import media_fullscreen from '@components/competitions/assets/images/fullscreen.webp';
import useFullscreenStatus from '@utils/useFullscreenStatus';
import React, {useEffect} from 'react';
import {useFullScreenHandle} from 'react-full-screen';
import screenfull from 'screenfull';

type Props = {
	children: any,
	backgroundColor?: any,
	remaining?: number,
	videoEnd?: boolean,
	mission?: number,
	help?: boolean,
	buttonColor?: string,
	helpAction?: () => void
	
}
export default function MaximizableView(props: Props) {
	const {children, backgroundColor, remaining, videoEnd, mission, help = false, helpAction, buttonColor} = props;
	const handle = useFullScreenHandle();
	const maximizableElement = React.useRef(null);
	let isFullscreen, setIsFullscreen;
	let errorMessage;
	useEffect(() => {
		if (videoEnd && screenfull.isFullscreen) {
			(async () => {
				await screenfull.exit();
			})();
		}
	}, [videoEnd]);
	try {
		[isFullscreen, setIsFullscreen] = useFullscreenStatus(maximizableElement);
	} catch (e) {
		errorMessage = 'Fullscreen not supported';
		isFullscreen = false;
		setIsFullscreen = undefined;
	}
	
	const handleExitFullscreen = () => document.exitFullscreen();
	
	function toggleFullScreen1() {
		if (screenfull.isEnabled) {
			screenfull.request(document.querySelector('.h_iframe-aparat_embed_frame') as HTMLElement);
		}
		// if (!document.fullscreenElement) {
		// 	document.documentElement.requestFullscreen();
		// } else if (document.exitFullscreen) {
		// 	document.exitFullscreen();
		// }
	}
	
	function toggleFullScreen2() {
		const target = maximizableElement.current;
		if (screenfull.isEnabled && target) {
			screenfull.request(target);
		} else {
			console.warn('No target element for fullscreen');
		}
	}
	
	function toggleFullScreen() {
		if (screenfull.isEnabled) {
			if (screenfull.isFullscreen) {
				// If already fullscreen, exit
				screenfull.exit();
			} else if (maximizableElement.current) {
				// Otherwise, request fullscreen
				screenfull.request(maximizableElement.current);
			} else {
				console.warn('No element found for fullscreen');
			}
		}
	}
	
	
	return (
		/*	<FullScreen handle={handle}>
		 <div className={`${handle.active ? '' : ''}`}>{children}</div>
		 {/!*@ts-ignore*!/}
		 <div className="w-full flex flex-row justify-center cursor-pointer" onClick={handle.enter}>
		 <img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-2"/>
		 </div>
		 </FullScreen>*/
		<div
			ref={maximizableElement}
			className={`maximizable-container ${
				isFullscreen ? 'fullscreen' : 'default'
			}`}
			// style={{backgroundColor: isFullscreen ? backgroundColor : null}}
		>
			<div className={``}>{children}</div>
			{
				// remaining !== 0 && !videoEnd && mission == 0 && (
				<div className="w-full flex flex-row justify-center cursor-pointer mt-3" onClick={() => {
					toggleFullScreen();
				}}>
					{
						buttonColor ? (
							<span className={`font-samir text-xl px-2 py-1 rounded-2xl border text-white`}
							      style={{
								      borderColor: buttonColor
							      }}
							>
								تمام صفحه
							</span>
						) : (
							<img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-2"/>
						)
					}
				</div>
				// )
			}
			{
				help && (
					<div className="w-full flex flex-row justify-center select-none" onClick={helpAction}>
						<div
							className="w-20 rounded-2xl bg-[#0b152b] text-[#62b694] cursor-pointer text-center scaleAnimate">راهنمایی
						</div>
					</div>
				)
			}
			{/*<div className={`maximizable-content ${isFullscreen ? 'p-2' : ''}`}>{children}</div>*/}
			{/*<div className="maximizable-actions">*/}
			{/*	{errorMessage ? (*/}
			{/*		<button*/}
			{/*			onClick={() =>*/}
			{/*				alert(*/}
			{/*					'Fullscreen is unsupported, please try again.'*/}
			{/*				)*/}
			{/*			}*/}
			{/*		>*/}
			{/*			{errorMessage}*/}
			{/*		</button>*/}
			{/*	) : isFullscreen ? (*/}
			{/*		// <button onClick={handleExitFullscreen}>Exit Fullscreen</button>*/}
			{/*		<div className="w-full flex flex-row justify-center cursor-pointer" onClick={handleExitFullscreen}>*/}
			{/*			/!*<img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-8"/>*!/*/}
			{/*			<div className="bg-[#62b694] p-3 rounded-3xl mt-5">خروج از حالت تمام صفحه</div>*/}
			{/*		</div>*/}
			{/*	) : (*/}
			{/*		// @ts-ignore*/}
			{/*		<div className="w-full flex flex-row justify-center cursor-pointer" onClick={setIsFullscreen}>*/}
			{/*			<img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-2"/>*/}
			{/*		</div>*/}
			{/*		// <button onClick={setIsFullscreen}>Fullscreen</button>*/}
			{/*	)}*/}
			{/*</div>*/}
		</div>
	);
}
